import './sidebar.scss';

import classNames from 'classnames';
import PropTypes from 'prop-types';
import { useAuth } from 'react-oidc-context';
import React, { useContext } from 'react';
import ClickAwayListener from 'react-click-away-listener';
import { QueryCache } from 'react-query';
import { NavLink } from 'react-router-dom';

import { ReactComponent as Contact } from '../../assets/icons/contact.svg';
import { ReactComponent as Logout } from '../../assets/icons/logout.svg';
import { ReactComponent as Notification } from '../../assets/icons/notification.svg';
import { ReactComponent as Settings } from '../../assets/icons/settings.svg';
import Close from '../../components/vectors/Close';
import { IS_ADMIN } from '../../config';
import { UserContext } from '../../context';
import { useHasPermission, useLogout } from '../../hooks';
import { Icon } from '..';
import { ProfileImage } from '../profile-image';

const Sidebar = ({ isMenuOpen, closeMenu, menuItems }) => {
  const { user } = useContext(UserContext);

  const logout = useLogout();

  const hasPermission = useHasPermission();

  const accessibleMenuItems = menuItems.filter(
    (item) => !item.hidden && (!item.permission || hasPermission(item.permission))
  );

  return (
    <aside
      className={classNames({
        sidebar: true,
        open: isMenuOpen
      })}>
      <ClickAwayListener
        onClickAway={(e) => {
          if (e.target.className !== 'introjs-button introjs-nextbutton') isMenuOpen && closeMenu();
        }}>
        <div className="sidebar__container">
          <button className="sidebar__close" onClick={closeMenu} data-testid="sidebar-close">
            <Close />
          </button>
          <div className="sidebar__header">
            <div className="sidebar__dropdown">
              <ProfileImage location="sidebar" />
              {IS_ADMIN ? (
                <span className="sidebar__dropdown--text">
                  <span className="text-bold">{user.firstName + ' ' + user.lastName}</span>
                  <span className="text-secondary">Admin</span>
                </span>
              ) : (
                <span className="sidebar__dropdown--text">
                  <span className="text-bold">{user.merchantName}</span>
                  <span className="text-secondary">Merchant</span>
                </span>
              )}
            </div>
            <button className="sidebar__header__item">
              <Notification />
            </button>

            <NavLink className="sidebar__header__item" to="/settings" onClick={closeMenu}>
              <Settings />
            </NavLink>
          </div>
          <nav className="sidebar__menu">
            {accessibleMenuItems.filter((item) => !item.hidden).map((item, index) => (
              <React.Fragment key={index}>
                {item.hasDivider && <span className="sidebar__menu-spacer" role="separator" />}
                <NavLink
                  className="sidebar__menu-item"
                  id={item.name.toLowerCase().replaceAll(' ', '-')}
                  to={item.path}
                  onClick={closeMenu}
                  exact={item.name === 'Dashboard'}
                  activeClassName="active">
                  <Icon className="sidebar__menu-icon" name={item.name} />
                  <span className="sidebar__menu-name">{item.name}</span>
                </NavLink>
              </React.Fragment>
            ))}
          </nav>
          <a
            className="sidebar__button"
            href="mailto:hello@basqet.com"
            target="_blank"
            rel="noreferrer">
            <Contact /> Contact support
          </a>
          <button className="sidebar__logout__button" onClick={logout}>
            <Logout />
            Logout
          </button>
        </div>
      </ClickAwayListener>
    </aside>
  );
};

Sidebar.defaultProps = {
  menuItems: []
};
Sidebar.propTypes = {
  isMenuOpen: PropTypes.bool,
  closeMenu: PropTypes.func,
  menuItems: PropTypes.array
};
export { Sidebar };
